import React from "react";
import "./styles.css";
import { ENTERPRISE_AUTOMATED } from "utils/constants";
import { useDispatch } from "react-redux";
import { setData } from "ducks/actions/index";
import FormattedMessage from "components/FormattedMessage/index";

const ThingsToKnow = ({
  enableSimCountNextBtn
}) => {
  const dispatch = useDispatch()
  const handleNextButtonClick = () => {
      dispatch(
        setData({
          key: "enableSimCountNextBtn",
          data: {
            enableSimCountNextBtn: true
          }
        })
      );
  }
  return (
    <div className="things-to-know-wrapper">
       <hr className="things-to-know-divider" />
      <div className="things-to-know-card">
        <div className="card-header">
          <h2>Things to know</h2>
        </div>
        
        <div className="card-body">
          {/* Getting new numbers section */}
          <div className="info-section">
            <div className="info-icon">
              <img
                src={ENTERPRISE_AUTOMATED.NEW_NUMBER_ICON}
                alt="New Number"
              />
            </div>
            <FormattedMessage html id="ent_getting_new_number_content" defaultMessage="" />
          </div>

          <hr className="divider" />

          {/* Transferring numbers section */}
          <div className="info-section">
            <div className="info-icon">
             <img
                src={ENTERPRISE_AUTOMATED.TRASNFER_NUMBER_ICON}
                alt="New Number"
              />
            </div>
            <FormattedMessage html id="ent_getting_transfer_number_content" defaultMessage="" />
          </div>
        </div>
      </div>

      {!enableSimCountNextBtn ?  (
        <button 
          className="got-it-btn" 
          onClick={handleNextButtonClick}
        >
          Got it
        </button>
      ): null}
    </div>
  );
};

export default ThingsToKnow;